/**
 * 공지 (/m/setting/notices 목록 · /m/notice/{id} 상세 · /m/notice/preview/{id} 관리자 팝업 미리보기) — 셋이 pageName 'Notice' 를 같이 쓴다
 * ($j.Pages.Mobile.Notice / body data-page-name="Notice")
 */
export default class Notice {
    initialize() {
        if ($('#noticeTable').length) this.initList();
        if ($('#errmgshowboxa').length) this.initDetail();

        // 관리자 팝업 미리보기 — 실제 앱에 뜨는 팝업 모습 (#page-data.previewItem)
        const item = JSON.parse(document.getElementById('page-data')?.textContent || '{}').previewItem;
        if (item) $j.F.Popup.preview(item);
    }

    /** 목록 — DataTable + 행 클릭 시 상세 시트 */
    initList() {
        // 공지 목록 — DataTable (검색/페이징). 정렬은 최신순 유지되도록 order 끔.
        $('#noticeTable').DataTable({
            paging: true,
            pageLength: 15,
            lengthChange: false,
            ordering: false,
            searching: false,   // 검색 제거
            info: false,
            language: {
                emptyTable: '등록된 공지가 없습니다.',
                paginate: { previous: '이전', next: '다음' },
            },
        });

        // 행 클릭 → 공지 상세 BottomSheet
        $('#noticeTable tbody').on('click', 'tr', function () {
            const num = $(this).data('num');
            if (!num) return;
            // fixedHeight: 패널 95vh 고정 + content-area 스크롤 확보(긴 이미지도 스크롤됨)
            $j.Ui.BS.open({ target: '$j.F.Mobile.NoticeBS', data: { num: num }, fixedHeight: true });
        });
    }

    /** 상세 — 이미지 확대 · 전체 목록 · '클릭 확대' 안내 잠깐 */
    initDetail() {
        $('.nd-img').on('click', function () { $j.Ui.ZoomPhoto.open(this.getAttribute('src')); });
        $('.nd-list-btn').on('click', () => { document.location.href = '/m/setting/notices'; });
        $('#errmgshowboxa').show().fadeOut(2000);
    }
}
